module.exports = __webpack_public_path__ + "static/media/founder.84c9846a.jpg";